import stepClasses from "@mui/material/Step/stepClasses";
import stepLabelClasses from "@mui/material/StepLabel/stepLabelClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiStepLabelTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                alignItems: "flex-start",
                columnGap: dt.inline.small,
                "::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 0,
                    [`.${stepClasses.completed}[class][class][class] &`]: {
                        borderTop: `${dt.borderWidth.small} solid ${dt.color.palette.primary[50]}`,
                    },
                    ".Mui-error[class][class] &": {
                        borderTop: `${dt.borderWidth.small} solid ${dt.color.outlineVariant}`,
                    },
                },
                [`&:has(.${stepLabelClasses.iconContainer}.Mui-error)::after`]: {
                    borderTop: `${dt.borderWidth.small} solid ${dt.color.outlineVariant}`,
                },
                [`&:has(.${stepLabelClasses.label}.Mui-active)::after`]: {
                    borderTop: `${dt.borderWidth.small} solid ${dt.color.outlineVariant}`,
                },
                "&.Mui-disabled[class][class][class]::after": {
                    borderTopColor: "transparent",
                },
                [`.${stepLabelClasses.iconContainer}`]: {
                    paddingRight: 0,
                    ".PixelIcon, svg": {
                        width: dt.size.large,
                        height: dt.size.large,
                    },
                    ".Pxl-StepLabel-completed, .Pxl-StepLabel-large": {
                        margin: "-2px",
                        width: dt.size.xLarge,
                        height: dt.size.xLarge,
                    },
                    [`&.${stepLabelClasses.active} svg`]: {
                        color: dt.color.palette.primary[50],
                    },
                    [`&:not(.${stepLabelClasses.active}):not(.${stepLabelClasses.completed})`]: {
                        opacity: dt.opacity.states.disabled.content,
                    },
                    ".Mui-disabled[class][class][class] &, &.Mui-disabled[class][class][class]": {
                        opacity: dt.opacity.states.disabled.content,
                        ".PixelIcon": {
                            color: dt.color.onSurface.key,
                        },
                    },
                    ".Mui-error[class][class][class] &, &[class][class][class].Mui-error": {
                        opacity: 1,
                        ".PixelIcon": {
                            color: dt.color.signal.error.key,
                        },
                    },
                },
                [`.${stepLabelClasses.labelContainer}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "subtitle2.regular")), { ".Pxl-StepLabel-optional": Object.assign(Object.assign({}, typographyResponsive(dt, "caption")), { color: dt.color.onSurface.variant }), [`&:has(.${stepLabelClasses.active}:not(.${stepLabelClasses.completed})) .Pxl-StepLabel-optional`]: {
                        color: dt.color.onSurface.key,
                    }, ".Mui-error & .Pxl-StepLabel-optional, &.Mui-error .Pxl-StepLabel-optional": {
                        color: dt.color.onSurface.key,
                    } }),
                [`.${stepLabelClasses.label}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "subtitle2.regular")), { color: dt.color.onSurface.variant, fontWeight: "normal", [`&.${stepLabelClasses.active}:not(.${stepLabelClasses.completed})`]: Object.assign(Object.assign({}, typographyResponsive(dt, "subtitle2.medium")), { color: dt.color.onSurface.key, fontWeight: "bold" }), [`&.${stepLabelClasses.completed}`]: {
                        fontWeight: "normal",
                    }, ".Mui-error &, &.Mui-error": {
                        color: dt.color.onSurface.key,
                    } }),
                "&.Mui-disabled[class], .Mui-disabled[class] &": {
                    [`.${stepLabelClasses.labelContainer}`]: {
                        color: dt.color.onSurface.variant,
                    },
                    [`.${stepLabelClasses.label}, .Pxl-StepLabel-optional`]: {
                        color: dt.color.onSurface.variant,
                        fontWeight: "normal",
                    },
                },
            },
        },
    };
};
